export const RESPONDANTS = 'respondants';
